<template lang="pug">
  b-modal#updateCMTN(
    ref="updateCMTN"
    :title="$t('ui.combine.update_commission')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    size="md"
    @ok="done"
    @show="reset"
    @shown="shown"
    :hide-footer="!$helpers.getVisible(editLimit)"
  )
    b-form(novalidate :disabled="!submission.success" @submit.stop.prevent="submit")
      span #[b {{ $t("ui.account_id") + " : " + accountId.toUpperCase() }}]
      #tblModal.table-sm.table-responsive.commission
        table.table.table-bordered
          tbody
            tr
              th {{ comm_tournament_title }}
              td
                PTSelect(
                  ref="comm_tournament"
                  :dirty="$v.comm_tournament.$dirty"
                  :error="$v.comm_tournament.$error"
                  :options="comm_tournament_options"
                  v-model="$v.comm_tournament.$model"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
      .form-group
        b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import config from "@/config";
import { required, maxValue } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import PTSelect from "@/library/PTSelect";

export default {
  components: {
    PTSelect,
    SubmitButton
  },
  props: {
    accountId: ""
  },
  data() {
    return {
      loading: false,
      comm_tournament: 0,
      submission: {
        success: true,
        status: ""
      }
    }
  },
  validations: {
    comm_tournament: {
      required,
      maxValue(value) {
        return maxValue(this.comm_tournament_max)(value)
      }
    }
  },
  computed: {
    editLimit: function() {
      return [config.accessRoles.editLimit]
    },
    comm_tournament_title: function() {
      return this.$t("ui.tournament") + " (" + this.comm_tournament_max + ")"
    },
    comm_tournament_max: function() {
      return this.$store.getters.getCommTN
    },
    comm_tournament_options: function() {
      return this.$helpers.getCommRateList1(this.comm_tournament_max, this.comm_tournament)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault()
      this.submit()
    },
    getChildCommission: function() {
      $("select").prop("disabled", !this.$helpers.getVisible(this.editLimit))
      let account_id = this.accountId
      let platform_code = "TOURNAMENT"
      if(account_id) {
        this.$store
        .dispatch("user/getChildCommission", { account_id, platform_code })
        .then(response => {
          this.$v.comm_tournament.$model = response.data.cm[0].account_commission
          $("select").prop("disabled", !this.$helpers.getVisible(this.editLimit))
        })
        .catch(response => {
        });
      } else {
        this.cancel()
      }
    },
    submit: function() {
      // this.reset()
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.update_account_commission_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.updateCommTN()
          } else if (
            // Read more about handling dismissals
            result.dismiss === 'cancel'
          ) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.update_account_commission_cancel"),
              type: "error",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        });
      }
    },
    updateCommTN: function() {
      let account_id = this.accountId
      let account_commission = this.comm_tournament
      this.$store
        .dispatch("user/updateCommissionTN", { account_id, account_commission })
        .then(response => {
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if(this.submission.success == true) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.succeed"),
              text: this.$t("message.update_account_commission_success"),
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        })
        .catch(response => {
          console.log("Failed:updateCommissionTN", response)
          this.loading = false;
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    reset: function() {
      this.submission.success = true
      this.submission.status = ""
      this.comm_tournament = 0
    },
    shown: function() {
      this.$nextTick(() => {
        this.$v.$reset()
        this.$helpers.getCommission()
        this.getChildCommission()
      });
    },
    cancel: function() {
      // this.$emit("clicked")
      this.$refs.updateCMTN.hide()
    }
  }
};
</script>

